<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/archive">
          <v-btn
            color="secondary"
            class="text-right"
            style="width:250px"
          >
            Back
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>December 26 to December 29, 2025 - Las Vegas</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/decVegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>December 3 to December 10, 2025 - Caesars Windsor/Las Vegas</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/dec3vegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>November 19 to November 25, 2025 - F1</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/f1vegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>September 8 to September 11, 2025 - Wizard of Oz at The Sphere</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/sepvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>   
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>August 20 to August 27, 2025 - Seven Stars Signature Event</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/augvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>      
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>August 7 to August 12, 2025 - Meet the Caesars Entertainment CEO</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/aug2vegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>        
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>July 14 to July 28, 2025 - Slot Tournament</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/julyvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>  
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>June 15 to June 22, 2025 - Kenny Chesney at the Sphere</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/junvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>   
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <s>April 15 to April 30, 2025 (Dead and Company)</s>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/aprvegas">
          <v-btn
            color="grey"
            class="text-right"
            style="width:250px;"
          >
            <s>Las Vegas</s>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>April 8 to April 16, 2025</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/korea">
          <v-btn
            color="grey"
            class="text-right"
            style="width:250px;"
          >
            Seoul
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>February 18 to March 14, 2025</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/febvegas">
          <v-btn
            color="grey"
            class="text-right"
            style="width:250px;"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>January 30 to February 18, 2025</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/uk">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px;"
          >
            UK
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <s>January 31 to February 5, 2025</s>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/iceland">
          <v-btn
            color="gray"
            class="text-right"
            style="width:250px;"
          >
            <s>Iceland</s>
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <div class="text-left">
          <p>January 25 to January 30, 2025</p>
        </div>
      </v-col>
      <v-col cols="6">
        <router-link to="/janvegas">
          <v-btn
            color="primary"
            class="text-right"
            style="width:250px"
          >
            Las Vegas
          </v-btn>
        </router-link>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

//vue 3 style
import { ref } from 'vue'

export default {
  name: 'Archive2025',
  setup() {
  }
}
</script>

